"use client";

import { useEffect } from "react";

function UpdatePopularPost({ postId }) {
  const updatePost = async (id) => {
    fetch(`/api/popular-posts`, {
      method: "POST",
      body: JSON.stringify({ id: Number(id) }),
    });
  };

  useEffect(() => {
    if(postId) updatePost(postId);
  }, [postId]);

  return null;
}

export default UpdatePopularPost;
